import styled from 'styled-components';
import {
  SimpleTable,
  SimpleTableContainer,
  SimpleTableHeader,
  SimpleTableRow,
  SimpleTableTitle,
  Loader,
  focusOutlinesStyles,
  Checkbox,
  IconChevronLeft,
  Button,
  PageHeaderWrapper,
  Heading,
  IconError
} from 'cdk-radial';
import { InputWrapperType } from './types';


export const StickySimpleTable = styled(SimpleTable)`
  position: relative;
  overflow: auto;
  width: 100%;                 
  table-layout: fixed;
`;

export const StickySimpleTableHeader = styled(SimpleTableHeader)<{
  textAlign: string;
  width?: string;
}>`
  position: sticky;
  top: 0;
  font-size: 12px;
  line-height: 14px;
  th {
    box-shadow: none;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  padding-left: ${props => (props.textAlign === 'left' ? `0rem` : `0.5rem`)};
  padding-right: ${props => (props.textAlign === 'right' ? `0rem` : `0.5rem`)};
  text-align: ${props =>
    props.textAlign === 'right' ? `-webkit-right` : `-webkit-left`};
  width: ${(props: InputWrapperType) => props.width ?? ''};
  max-width: ${(props: InputWrapperType) => props.width ?? ''};
`;

export const StickySimpleTableContainer = styled(SimpleTableContainer)`
  max-width: '400px';
  overflow: auto;
  margin: '8px';
  min-height: '150px';
  height: '150px' 
 
`;

export const ZebraSimpleTableRow = styled(SimpleTableRow)`
  :nth-child(even) {
    background-color: #151b2503;
    border-top: 1px solid #dcddde;
    background: #F2F2F2;
    :hover {
      background-color: ${({ theme }) =>
        theme.color.zebraStripe.hover.value as string};
    }
  }
  &:last-child {
    border-bottom: none;
  }
  cursor: pointer;
`;

export const StyledSimpleTableTitle = styled(SimpleTableTitle)`
  font-size: 18px;
  line-height: 24px;
`;

export const StyledIndicatorContainer = styled.div`
  display: flex;
`;

export const StyledAddInvoiceCheckBox = styled(Checkbox)`
  padding-right: 0.8rem;
`;

export const StyledAddInvoiceHeaderCheckBox = styled.div`
  padding-top: 0.8rem;
`;

export const StyledIndicatorLabelContainer = styled.div`
  padding-top: 0.2rem;
`;

export const FullWidthTableData = styled.td`
  height: 50vh;
  width: 100%;
  text-align: center;
`;

export const StyledLoader = styled(Loader)`
  display: flex;
`;

/* eslint-disable */
export const FocusWrapper = styled.div`
  /* true if the wrapped Button has focus */
  &:has(:focus) {
    button {
      background-color: ${({ theme }) =>
        theme?.color?.button?.primary?.background?.hover?.value};
      ${focusOutlinesStyles.primary};
    }
  }
`;
/* eslint-disable */
export const FocusWrapperIcon = styled.div`
  /* true if the wrapped Button has focus */
  &:has(:focus) {
    button {
      box-shadow: 0 0 0 4px rgb(0 0 0 / 50%);
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.15);
    }
  }
`;

export const ContentSeparator = styled.div`
  width: 1px;
  background-color: #dfdfdf;
  padding-top: 0.5rem;
`;

export const VariedWidthSection = styled.div<InputWrapperType>`
  width: ${(props: InputWrapperType) => props.width || `100%`};
`;

export const StyledBackButton = styled(IconChevronLeft)`
  fill: black;
`;

export const StyledHeaderTitleWrapper = styled.div`
  display: flex;
`;

export const StyledOrderHeaderButton = styled(Button)`
  margin-left: 8px;
`;

export const StyledWarningButton = styled(Button)`
  margin-left: 8px;
  background-color: #fa9c19 !important;
`;

export const StyledPageHeaderButtonContainer = styled.div`
  display: flex;
  padding: 12px 16px 12px 0;
`;

export const StyledPageHeaderTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 60px;
`;

export const StyledPageHeaderWrapper = styled(PageHeaderWrapper)`
  display: flex;
  margin-bottom: 10px;
  flex-direction: column;
`;

export const StyledPanelHeader = styled(Heading)`
  width: 95%;
`;

export const StyledPanelHeaderContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledSidePanelContainer = styled.div`
  padding: 10px 10px 0px 10px;
  alignitems: flex-end;
  flexdirection: column;
  flexgrow: 1;
`;
export const StyledH5 = styled.h5`
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
`;

export const StyledIconErrorCircle = styled(IconError)`
  fill: ${({ theme }) => theme.color.secondary.cherryBombRed[500].value};
  height:12px;
  width:12px;
`;